var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownloadDesktopBackground = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 857,
    height: 1066,
    viewBox: "0 0 857 434",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M857 440.229C857 611.501 720.21 750 546.997 750C373.784 750 238.806 614.959 238.806 440.229C238.806 358.052 269.955 285.426 319.397 230.916L109.927 440.229L0 330.385L236.334 96.6982C268.307 64.7495 284.788 23.0844 284.788 -22.6978V-316H439.707V-22.6978C439.707 67.2197 407.734 143.468 345.272 205.719L338.35 212.636C392.902 162.407 467.395 132.105 546.997 132.105C722.847 132.105 857 271.428 857 440.065M716.749 440.065C716.749 348.336 640.608 273.898 546.997 273.898C453.386 273.898 379.058 351.794 379.058 440.065C379.058 528.335 453.551 607.878 546.997 607.878C640.443 607.878 716.749 529.159 716.749 440.065Z",
    fill: "white",
    fillOpacity: 0.3
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownloadDesktopBackground);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/download-desktop-background.a84fbf690614855ce0f43411b7608132.svg";